/* eslint-disable */
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import KirtanLinePlate from "../pageComponents/KirtanLinePlate";
import PreSettingModal from "../Modals/PreSettingModal";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CastIcon from "@mui/icons-material/Cast";
import VideoCameraBackIcon from "@mui/icons-material/VideoCameraBack";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ScreenshotMonitorIcon from "@mui/icons-material/ScreenshotMonitor";
import SettingModal from "../Modals/SettingModal";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import ConfirmBox from "../UserInteractive/ConfirmBox";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReactSortable } from "react-sortablejs";
import { setBookList, setKirtanList, setContentKirtanList } from "../../Slice/formSlice";
import {
  setCurrKirtanIndex,
  setKirtanIndex,
  setSelectedLine,
  setShortcutIndex,
  setSeqId,
  setBookId,
  setDatabaseId,
} from "../../Slice/KirtanIndexSlice";
import { setSelectedId, setSettingsOpen, togglePreSettings } from "../../Slice/settingsSlice";
import IndexedDBService, { keyboardSettings, storeName } from "../../Utils/DBConfig";
import CircularProgress from "@mui/material/CircularProgress";
import handleContent from "../../services/kirtanContent.service";
import { setIsSerialConnected } from "../../Slice/keyBoardSlice";
import OBSWebSocket from "obs-websocket-js/json";
import { Virtuoso } from "react-virtuoso";
import { toast } from "react-toastify";
import TimerButton from "../UserInteractive/TimerButton";
import api from "../../Utils/Interceptor";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CircleIcon from "@mui/icons-material/Circle";
import AddIcon from "@mui/icons-material/Add";
import { tabGroupsStore } from "../../Utils/DBConfig";
import { sulekhToGujUnicodeConverter } from "../../services/converter.service";

const KirtanArea = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const obsClient = new OBSWebSocket();

  // Add global style for centering all child elements
  React.useEffect(() => {
    const styleEl = document.createElement("style");
    styleEl.innerHTML = `
      .kirtan-line-content * {
        text-align: center !important;
      }
    `;
    document.head.appendChild(styleEl);
    return () => {
      document.head.removeChild(styleEl);
    };
  }, []);

  let rxCommand = [];
  let port;
  let writer;
  let textEncoder;
  let writableStreamClosed;

  const selectedLineRef = useRef(null);
  const containerRef = useRef(null);
  const virtuosoRef = useRef(null);

  // ─── Refs to avoid stale closures in the keydown handler ───────────────────
  const currLineIndexRef = useRef(0);
  const favLinesRef = useRef([]);
  const isSettingsOpenRef = useRef(false);
  const isPreSettingsOpenRef = useRef(false);
  // getKirtanById depends on kirtanData + kirtanId — keep a ref to the latest fn
  const getKirtanByIdRef = useRef(null);
  // ───────────────────────────────────────────────────────────────────────────

  const [selectedOnZoomButton, setSelectedOnZoomButton] = React.useState([]);

  const [open, setOpen] = useState(false);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [multiScreenShotProcess, setMultiScreenShotProcess] = useState(false);

  const [preSettingModalOpen, setPreSettingsModalOpen] = useState(false);

  const [searchModalOpen, setSearchModalOpen] = useState(false);

  const [reloadFlag, setReloadFlag] = useState(false);

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [loaderEffect, setLoaderEffect] = useState(false);
  const [dataReachEaded, setDataReachEaded] = useState(false);

  const [pageValue, setPageValue] = useState(0);

  const [isLive, setIsLive] = useState(false);

  const [isSource, setIsSource] = useState(false);

  const [isRecord, setIsRecord] = useState(false);

  const [isStream, setIsStream] = useState(false);

  const [isVCam, setIsVCam] = useState(false);

  const [selectedProjection, setSelectedProjection] = useState(null);

  const [padList, setPadList] = useState([]);

  const [favLines, setFavLines] = useState([]);

  const [kirtanData, setKirtanData] = useState([]);

  const [tabGroups, setTabGroups] = useState([]);

  const [contextMenu, setContextMenu] = useState(null);

  const [contextKirtanId, setContextKirtanId] = useState(null);

  const [lineHistory, setLineHistory] = useState([]);

  const [currLineIndex, setCurrLineIndex] = useState(0);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [usedShortcut, setUsedShortcut] = useState(null);

  const [hoverKirtanIndex, setHoverKirtanIndex] = useState(null);

  const [hoveredFavLineIndex, setHoveredFavLineIndex] = useState(null);

  const [hoveredRegularLineIndex, setHoveredRegularLineIndex] = useState(null);

  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const [searchBarValue, setSearchBarValue] = useState("");

  const [selectedPlate, setSelectedPlate] = useState(0);

  const [presetId, setPresetId] = useState(null);

  const APIurl = useSelector((state) => state.db.url);

  const selectedLine = useSelector((state) => state.kirtanIndex.selectedLine);

  const kirtanId = useSelector((state) => state.kirtanIndex.kirtanId);

  const seq_id = useSelector((state) => state.kirtanIndex.seq_id);

  const book_id = useSelector((state) => state.kirtanIndex.book_id);

  const database_id = useSelector((state) => state.kirtanIndex.database_id);

  const kirtanLineId = useSelector((state) => state.kirtanIndex.currIndex);

  const searchFlag = useSelector((state) => state.kirtanIndex.searchFlag);

  const isDbInitialized = useSelector((state) => state.db.isDbInitialized);

  const bookList = useSelector((state) => state.FormList.book_list);

  const kirtanList = useSelector((state) => state.FormList.kirtan_list);

  const content_kirtan_list = useSelector((state) => state.FormList.content_kirtan_list);

  const { sourceMode, recordMode, streamMode, vMixApi, mixerApi, vCam, obs } = useSelector((state) => state.vMixButton);

  // pre setting data
  const isSettingsOpen = useSelector((state) => state.settings.open);
  const isDualLineMode = useSelector((state) => state.settings.isDualLineMode);
  const isPreSettingsOpen = useSelector((state) => state.settings.preSettingsOpen);
  const preSettings = useSelector((state) => state.settings.preSettings);
  const selectedId = useSelector((state) => state.settings.selectedId);

  const isSerialConnected = useSelector((state) => state.keyboardSlice.isSerialConnected);

  const vMixZoomButton = useSelector((state) => state.vMixZoomButton.VMixZoomButton);

  // ─── Keep refs in sync with latest state/callbacks ─────────────────────────
  useEffect(() => {
    currLineIndexRef.current = currLineIndex;
  }, [currLineIndex]);
  useEffect(() => {
    favLinesRef.current = favLines;
  }, [favLines]);
  useEffect(() => {
    isSettingsOpenRef.current = isSettingsOpen;
  }, [isSettingsOpen]);
  useEffect(() => {
    isPreSettingsOpenRef.current = isPreSettingsOpen;
  }, [isPreSettingsOpen]);
  // ───────────────────────────────────────────────────────────────────────────

  const textFieldStyles = {
    borderRadius: "999px",
    width: isSearchFocused || searchBarValue ? "500px" : "200px",
    height: "26px",
    transition: "width 0.3s",
    backgroundColor: "#FFFFFF",
    "&.Mui-focused": {
      backgroundColor: "#FFFFFF",
    },
  };

  const inputProp = {
    style: {
      borderRadius: "999px",
      height: "26px",
      padding: "4px",
    },
  };

  const handleRegularLineHover = (index) => setHoveredRegularLineIndex(index);

  const handleFavLineHover = (index) => setHoveredFavLineIndex(index);

  const handleShowDeleteConfirm = (x) => setShowDeleteConfirm(x);

  const handleFocus = () => {
    setIsSearchFocused(true);
  };

  const timeOut = (timeDuration = 1000) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        setIsSearchFocused(false);
      }, timeDuration);
    });
  };

  const handleBlur = (event) => {
    timeOut(1400);
  };

  const handleChangeSearchBarValue = (event) => {
    setSearchBarValue(event.target.value);
    setPageValue(0);
  };

  const masterData = async () => {
    return new Promise(async (resolve, reject) => {
      const url = `${APIurl}/api/kirtan/masterData-list`;
      const res = await api.get(url);
      const dataList = await res.data.data;
      dispatch(setBookList(dataList.book_list));
      resolve(true);
    });
  };

  const handleSeqFetchData = async (data, tab) => {
    const finalContent = handleContent(data.content);
    setReloadFlag(!reloadFlag);
    const maxOrder = kirtanData.length > 0 ? Math.max(...kirtanData.map((k) => k.order || 0)) : 0;
    const currentIndex = tab ? kirtanData.findIndex((k) => k.id === Number(kirtanId)) : -1;

    const dbData = {
      id: tab ? Number(kirtanId) : kirtanData.length > 0 ? Math.max(...kirtanData.map((k) => k.id)) + 1 : 0,
      title: data.unicode_title,
      english_title: data.english_title || "",
      content: finalContent,
      page_no: data.page_no || "",
      shortcuts: {
        0: "1",
        1: "2",
        2: "3",
        3: "4",
        4: "5",
        5: "6",
        6: "7",
        7: "8",
        8: "9",
      },
      seq_id: data.seq_id || 0,
      book_id: data.book_id || 0,
      database_id: data.id || 0,
      originalContent: data.content,
      settings: {
        fontSize: "50px",
        fontWeight: "500",
        color: "#ffffff",
        backgroundColor: "#000000",
        height: "100px",
        textShadowColor: "#ffffff",
        textShadowWidth: "0px",
        isDualLineMode: false,
      },
      favLines: [0, 1],
      lineHistory: [],
      selectedLine: 0,
      selectedPlate: 1,
      order: currentIndex,
    };

    if (isDbInitialized) {
      if (tab) {
        IndexedDBService.updateItem(dbData, storeName)
          .then(() => {
            dispatch(setKirtanIndex(dbData.id));
            setReloadFlag(!reloadFlag);
            dispatch(setCurrKirtanIndex(0));
            setCurrLineIndex(0);
          })
          .then(() => {
            timeOut(1400);
          });
      } else {
        IndexedDBService.addItem(dbData, storeName)
          .then(() => {
            dispatch(setKirtanIndex(dbData.id));
            setReloadFlag(!reloadFlag);
            dispatch(setCurrKirtanIndex(0));
            setCurrLineIndex(0);
          })
          .then(() => {
            timeOut(1400);
          })
          .catch((error) => console.error(error));
      }
    }
  };

  const handlePrevious = async () => {
    let queryString = `?book_id=${book_id}&seq_id=${seq_id - 1}&page=${0}&limit=${50}`;
    try {
      const url = `${APIurl}/api/kirtan/filterList${queryString}`;
      const res = await api.get(url);
      const dataList = res.data.data;
      const dataObj = dataList[0];
      if (dataObj) handleSeqFetchData(dataObj, true);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePadClick = async (id) => {
    try {
      if (id === 0) return;
      const url = `${APIurl}/api/kirtan/id/${id}`;
      const res = await api.get(url);
      const kirtanById = res.data.data;
      if (kirtanById) handleSeqFetchData(kirtanById, true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFilterChange = async () => {
    try {
      let queryString = `?search=${searchBarValue}&page=${pageValue}`;
      const url = `${APIurl}/api/kirtan/search${queryString}`;
      const res = await api.get(url);
      const dataList = res.data.data;

      if (dataList.find_kirtan_by_title.length === 0 && dataList.find_kirtan_by_content.length === 0) {
        setLoaderEffect(false);
        setDataReachEaded(true);
      } else {
        setDataReachEaded(false);
      }
      if (pageValue === 0) {
        dispatch(setKirtanList(dataList.find_kirtan_by_title));
        dispatch(setContentKirtanList(dataList.find_kirtan_by_content));
      } else {
        dispatch(setKirtanList([...kirtanList, ...dataList.find_kirtan_by_title]));
        dispatch(setContentKirtanList([...content_kirtan_list, ...dataList.find_kirtan_by_content]));
      }
      setLoaderEffect(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNext = async () => {
    let queryString = `?book_id=${book_id}&seq_id=${seq_id + 1}&page=${0}&limit=${50}`;
    try {
      const url = `${APIurl}/api/kirtan/filterList${queryString}`;
      const res = await api.get(url);
      const dataList = res.data.data;
      const dataObj = dataList[0];
      if (dataObj) handleSeqFetchData(dataObj, true);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchKirtanPadList = async () => {
    try {
      const url = `${APIurl}/api/kirtan/pad-list/${database_id}`;
      const res = await api.get(url);
      const padList = await res.data.data;
      setPadList(padList);
    } catch (error) {
      console.log(error);
    }
  };

  const handleModalToggle = (value) => {
    dispatch(setSettingsOpen(value));
    setOpen(value);
  };

  const handlePreSettingModalToggle = (value) => {
    setPreSettingsModalOpen(value);
    dispatch(togglePreSettings(value));
    if (!value) {
      setPresetId(null);
    }
  };

  const handleCurrLineIndex = (index) => {
    setCurrLineIndex(index);
    dispatch(setCurrKirtanIndex(index));
    dispatch(setSelectedLine(index));

    let kirtanData = { ...getKirtanById() };
    kirtanData.selectedLine = index;
    if (isDbInitialized) {
      IndexedDBService.updateItem(kirtanData, storeName)
        .then(() => {})
        .catch((error) => console.error(error));
    }
  };

  const handleChange = async (x) => {
    const res = await handleVMixInput(x);
    res && setIsLive(x);
    res && localStorage.setItem("isLive", JSON.stringify(x));
  };

  const handleScreenShotClick = async (flag) => {
    let vmixSettings = localStorage.getItem("vmixSettings");
    let multiScreenShotProcessFlag = flag || multiScreenShotProcess;
    if (vmixSettings) {
      vmixSettings = JSON.parse(vmixSettings);
      const d = new Date();
      const currentTime = `${d.getHours()}_${d.getMinutes()}_${d.getSeconds()}_${d.getMilliseconds()}`;
      let url = `${vmixSettings.webControllerUrl}/api/?Function=SnapshotInput&Input=ICG&Value=mysnapshot%20%7B0:dd%20MMM%20yyyy%7D%20${currentTime}.png`;
      console.log("url: ", url);
      try {
        const response = await fetch(url, {
          method: "GET",
        });
        console.log("response: ", response.status);
        if (response.ok) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  };

  const handleMultiScreenShot = async () => {
    if (multiScreenShotProcess) {
      setMultiScreenShotProcess(false);
    } else {
      setMultiScreenShotProcess(true);
      const res = await handleMultiScreenShotClick();
      res && setMultiScreenShotProcess(false);
    }
  };

  const handleMultiScreenShotClick = async () => {
    for (let index = currLineIndex; index < getKirtanById().content.length; index++) {
      setCurrLineIndex(index);
      dispatch(setCurrKirtanIndex(index));
      await handleScreenShotClick();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    return true;
  };

  const handleMixerApi = async (flag) => {
    try {
      let vmixSettings = JSON.parse(localStorage.getItem("vmixSettings"));
      console.log("api", `${vmixSettings.mixerApiUrl}`);
      const response = await fetch(`${vmixSettings.mixerApiUrl}`, {
        method: "POST",
      });
      if (response.status === 200) {
        setIsLive(flag);
      }
    } catch (error) {
      setIsLive(!flag);
      console.log("error: ", error);
    }
  };

  const handleVMixInput = async (flag) => {
    try {
      let vmixSettings = JSON.parse(localStorage.getItem("vmixSettings"));

      if (vmixSettings && mixerApi) handleMixerApi(flag);

      if (vmixSettings && obs) {
        await obsClient.connect("ws://localhost:4455");
        const { currentProgramSceneName } = await obsClient.call("GetCurrentProgramScene");
        const { sceneItems } = await obsClient.call("GetSceneItemList", { sceneName: currentProgramSceneName });
        const item = sceneItems.find((i) => i.sourceName === "ICG");

        const res = await obsClient.call("SetSceneItemEnabled", {
          sceneName: currentProgramSceneName,
          sceneItemId: item.sceneItemId,
          sceneItemEnabled: flag,
        });

        return true;
      }

      if (vmixSettings && vMixApi) {
        if (
          vmixSettings.webControllerUrl === "" ||
          vmixSettings.overlayChannelId === "" ||
          vmixSettings.inputId === "" ||
          vmixSettings.twoLineInputId === ""
        )
          return false;

        let func = "OverlayInput";
        if (flag) func = func + vmixSettings.overlayChannelId + "In";
        else func = func + vmixSettings.overlayChannelId + "Out";

        let url = `${vmixSettings.webControllerUrl}/api/?Function=${func}&input=${vmixSettings.inputId}`;
        try {
          await fetch(url, { mode: "no-cors" });
          return true;
        } catch (e) {
          console.log("e: ", e);
          return false;
        }
      }
    } catch (error) {
      console.error("Error in handleVMixInput:", error);
    }
  };

  const handleVMixSource = async () => {
    let vmixSettings = localStorage.getItem("vmixSettings");

    if (obs) {
      try {
        await obsClient.connect("ws://localhost:4455");
        const { currentProgramSceneName } = await obsClient.call("GetCurrentProgramScene");
        const { sceneItems } = await obsClient.call("GetSceneItemList", { sceneName: currentProgramSceneName });
        const item = sceneItems.find((i) => i.sourceName === "Source");
        await obsClient.call("SetSceneItemEnabled", {
          sceneName: currentProgramSceneName,
          sceneItemId: item.sceneItemId,
          sceneItemEnabled: !isSource,
        });
        return true;
      } catch (err) {
        alert('Failed to toggle "source": ' + err.message);
      }
    }
    if (vmixSettings && !obs) {
      vmixSettings = JSON.parse(vmixSettings);
      if (vmixSettings.webControllerUrl === "") return false;

      let url = `${vmixSettings.webControllerUrl}/api/?Function=OverlayInput1&input=Source`;
      try {
        await fetch(url, { mode: "no-cors" });
        return true;
      } catch (e) {
        console.log("e: ", e);
        return false;
      }
    }
  };

  const handleTabPress = async () => {
    const flag = !isSource;
    try {
      const res = await handleVMixSource();
      if (res) {
        setIsSource(flag);
      }
    } catch (error) {
      console.error("Error in handleVMixSource:", error);
    }
  };

  // Line History
  const handleLineHistory = (line) => {
    let history = lineHistory.length > 0 ? [...lineHistory] : [];

    const existingIndex = history.indexOf(line);

    if (existingIndex !== -1) {
      history.splice(existingIndex, 1);
    }

    if (history.length > 9) history.shift();

    history.push(line);

    let kirtanData = { ...getKirtanById() };
    kirtanData.lineHistory = history;

    setLineHistory(history);

    if (isDbInitialized) {
      IndexedDBService.updateItem(kirtanData, storeName)
        .then(() => {})
        .catch((error) => console.error(error));
    }
  };

  // Favrorite Lines
  const handleFavLines = (id) => {
    let favoriteLines = favLines.length > 0 ? [...favLines] : [];

    if (favoriteLines.includes(id)) favoriteLines = favLines.filter((lineId) => lineId !== id);
    else favoriteLines = [...favLines, id];

    setFavLines(favoriteLines);

    let currKirtanData = { ...getKirtanById() };
    currKirtanData.favLines = favoriteLines;

    isDbInitialized &&
      IndexedDBService.updateItem(currKirtanData, storeName)
        .then(() => {})
        .catch((error) => console.error(error));
  };

  // Get Kirtan By Id
  const getKirtanById = () => {
    return kirtanData.length > 0 && kirtanData.find((kirtan) => kirtan.id === kirtanId);
  };

  // Keep getKirtanByIdRef updated so keydown handler always has the latest version
  useEffect(() => {
    getKirtanByIdRef.current = getKirtanById;
  });

  const findBookName = (id) => {
    const book = bookList?.find((book) => book.id === id);
    return book ? book.name : null;
  };

  const findBookShortName = (id) => {
    const book = bookList?.find((book) => book.id === id);
    return book ? book.short_code : null;
  };

  const handlePreSettingModal = (id) => {
    handlePreSettingModalToggle(true);
    setPresetId(id);
  };

  const getUpdatedList = (data) => {
    const filteredIds = data.map((ele) => {
      delete ele.chosen;
      return Number(ele);
    });

    setFavLines(filteredIds);
    let currKirtanData = { ...getKirtanById() };
    currKirtanData.favLines = filteredIds;

    isDbInitialized &&
      IndexedDBService.updateItem(currKirtanData, storeName)
        .then(() => {})
        .catch((error) => console.error(error));
  };

  const handleClearHistory = () => {
    setLineHistory([]);
    let kirtanData = { ...getKirtanById() };
    kirtanData.lineHistory = [];
    isDbInitialized &&
      IndexedDBService.updateItem(kirtanData, storeName)
        .then(() => {})
        .catch((error) => console.error(error));
  };

  const handleHistorySwitch = (isForward) => {
    const index = lineHistory.findIndex((line) => line === currLineIndex);

    if (index === -1) return;

    const nextLine = lineHistory[isForward ? index + 1 : index - 1];

    if (nextLine === undefined) return;
    handleCurrLineIndex(nextLine);
  };

  const handleKey = async (event) => {
    let flag = localStorage.getItem("isLive") === "true" ? true : false;
    if (!isSettingsOpen) {
      if (event.key === "Escape") flag = false;
      else if (event.key === " ") flag = !flag;
      else event.preventDefault();

      const res = await handleVMixInput(flag);

      localStorage.setItem("isLive", JSON.stringify(flag));

      res && setIsLive(flag);
    }
  };

  //handle search modal
  const handleSearchModalToggle = (value) => {
    dispatch(setSettingsOpen(value));
    setSearchModalOpen(value);
  };

  const deleteKirtanById = (id) => {
    isDbInitialized &&
      IndexedDBService.deleteItem(Number(id))
        .then(() => {
          IndexedDBService.getAllData(storeName).then((data) => {
            if (Number(id) === Number(kirtanId)) {
              dispatch(setKirtanIndex(data[0]?.id || 0));
              navigate("/");
            }
            setReloadFlag(!reloadFlag);
          });
        })
        .catch((error) => console.error(error));
  };

  const handleDelete = () => {
    deleteKirtanById(kirtanId);
    handleShowDeleteConfirm(false);
  };

  // Pre Setting
  const handlePreSettingApply = (id) => {
    setSelectedPlate(id);
    let kirtanData = { ...getKirtanById() };
    kirtanData.selectedPlate = id;
    if (isDbInitialized) {
      IndexedDBService.updateItem(kirtanData, storeName)
        .then(() => {})
        .catch((error) => console.error(error));
    }
  };

  const handleVMixButtons = async (flag, name) => {
    let vmixSettings = localStorage.getItem("vmixSettings");

    if (obs) {
      try {
        await obsClient.connect("ws://localhost:4455");
        switch (name) {
          case "StartRecording":
            await obsClient.call("StartRecord");
            setIsRecord(true);
            break;
          case "StopRecording":
            setIsRecord(false);
            await obsClient.call("StopRecord");
            break;
          case "StartStreaming":
            await obsClient.call("StartStream");
            setIsStream(true);
            break;
          case "StopStreaming":
            console.log("StopStreaming: ");
            setIsStream(false);
            await obsClient.call("StopStream");
            break;
          case "StartVirtualCam":
            setIsVCam(true);
            await obsClient.call("StartVirtualCam");
            break;
          case "StopVirtualCam":
            setIsVCam(false);
            await obsClient.call("StopVirtualCam");
            break;
          default:
            break;
        }
        return true;
      } catch (error) {
        return false;
      }
    }

    if (vmixSettings) {
      vmixSettings = JSON.parse(vmixSettings);
      if (vmixSettings.webControllerUrl === "") return false;
      let url = `${vmixSettings.webControllerUrl}/api/?Function=${name}`;
      try {
        await fetch(url, { mode: "no-cors" });
        toast.success(url);
        switch (name) {
          case "StartRecording" || "StopRecording":
            setIsRecord(flag);
            break;
          case "StartStreaming" || "StopStreaming":
            setIsStream(flag);
            break;
          default:
        }
        return true;
      } catch (e) {
        toast.error(url);
        console.log("e: ", e);
        return false;
      }
    }
  };

  const handleVMixButtonsClick = (buttonName) => {
    switch (buttonName) {
      case "record":
        handleVMixButtons(!isRecord, !isRecord ? "StartRecording" : "StopRecording");
        break;
      case "stream":
        handleVMixButtons(!isStream, !isStream ? "StartStreaming" : "StopStreaming");
        break;
      case "vCam":
        handleVMixButtons(!isVCam, !isVCam ? "StartVirtualCam" : "StopVirtualCam");
        break;
      case "sourceOverlay":
        handleTabPress();
        break;
      default:
        break;
    }
  };

  // serial port functions
  const handleConnectClick = () => {
    if (navigator.serial) {
      connectSerialPort();
    } else {
      alert("Web Serial API not supported.");
    }
  };

  const connectSerialPort = async () => {
    try {
      port = await navigator.serial.requestPort();
      await port.open({ baudRate: 115200 });

      textEncoder = new TextEncoderStream();
      writableStreamClosed = textEncoder.readable.pipeTo(port.writable);

      writer = textEncoder.writable.getWriter();
      dispatch(setIsSerialConnected(true));
      listenToPort();
    } catch (error) {
      console.log("error: ", error);
      dispatch(setIsSerialConnected(false));
    }
  };

  const listenToPort = async () => {
    const textDecoder = new TextDecoderStream();
    const readableStreamClosed = port.readable.pipeTo(textDecoder.writable);
    const reader = textDecoder.readable.getReader();
    while (true) {
      const { value, done } = await reader.read();
      if (done) {
        reader.releaseLock();
        break;
      }
      appendToTerminal(value);
    }
  };

  const extractAndRemoveNumbers = async (buffer) => {
    const regex = /:(\d+):/g;
    let match;
    let updatedBuffer = buffer;
    const numbers = [];

    while ((match = regex.exec(buffer)) !== null) {
      numbers.push((match[1], 10));
      updatedBuffer = updatedBuffer.replace(`:${match[1]}:`, "");
    }

    return {
      numbers,
      updatedBuffer,
    };
  };

  const appendToTerminal = async (newStuff) => {
    rxCommand = rxCommand + newStuff;

    const result = await extractAndRemoveNumbers(rxCommand);
    if (result.numbers.length > 0) {
      const data = await IndexedDBService.getAllData(keyboardSettings);
      let arr = result.numbers;
      console.log("received number: ", arr);
      if (arr) {
        for (let index = 0; index < arr.length; index++) {
          const button = data.find((key) => key.id === +arr[index]);
          console.log("button: ", button);
          if (button) {
            processApiCalls(button);
          }
        }
      }
      console.log("Updated Buffer:", result.updatedBuffer);
    } else {
      console.log("No numbers found");
    }
    rxCommand = result.updatedBuffer;
  };

  const processApiCalls = (data) => {
    ["get1", "get2", "get3"].forEach((field) => {
      if (data[field].flag) {
        axios
          .get(data[field].api)
          .then((response) => {
            console.log(`GET ${field} response:`, response.data);
          })
          .catch((error) => {
            console.error(`GET ${field} error:`, error);
          });
      }
    });

    ["post1", "post2"].forEach((field) => {
      if (data[field].flag) {
        axios
          .post(data[field].api)
          .then((response) => {
            console.log(`POST ${field} response:`, response.data);
          })
          .catch((error) => {
            console.error(`POST ${field} error:`, error);
          });
      }
    });
  };

  const handleApiCall = async (id) => {
    const selectedButton = vMixZoomButton.find((button) => button.id === +id);
    let vmixSettings = localStorage.getItem("vmixSettings");
    if (vmixSettings) {
      vmixSettings = JSON.parse(vmixSettings);
      let url = `${vmixSettings.webControllerUrl}/${selectedButton.api}`;
      try {
        await fetch(url, { mode: "no-cors" });
        return true;
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  };

  const handleZoomCLick = async (id) => {
    const apiResponse = await handleApiCall(id);
    if (apiResponse) {
      if (id >= 1 && id <= 6) {
        setSelectedOnZoomButton((prevSelected) => [...prevSelected.filter((value) => value < 1 || value > 6), id]);
      } else {
        setSelectedOnZoomButton((prevSelected) => (prevSelected.includes(id) ? prevSelected.filter((value) => value !== id) : [...prevSelected, id]));
      }
    }
  };

  const handleProjectionButtonClick = async (name) => {
    try {
      await obsClient.connect("ws://localhost:4455");
      const { sceneItems } = await obsClient.call("GetSceneItemList", { sceneName: "Projection" });
      for (const item of sceneItems) {
        const shouldShow = item.sourceName === name;
        await obsClient.call("SetSceneItemEnabled", {
          sceneName: "Projection",
          sceneItemId: item.sceneItemId,
          sceneItemEnabled: shouldShow,
        });
      }
      setSelectedProjection(name);
    } catch (error) {
      console.error("Error connecting to OBS:", error);
    }
  };

  useEffect(() => {
    handleFilterChange();
    masterData();
    const body = document.querySelector("body");

    body.style.overflow = "hidden";

    return () => (body.style.overflow = "auto");
  }, []);

  useEffect(() => {
    if (virtuosoRef.current && selectedLine !== null && selectedLine !== undefined) {
      virtuosoRef.current.scrollToIndex({
        index: selectedLine,
        align: "center",
        behavior: "smooth",
      });
    }
  }, [selectedLine]);

  useEffect(() => {
    if (kirtanId && kirtanId != selectedIndex) {
      setSelectedIndex(Number(kirtanId));
      setUsedShortcut(null);
    }
  }, [kirtanId]);

  useEffect(() => {
    handleFilterChange();
  }, [pageValue]);

  useEffect(() => {
    if (kirtanLineId) handleCurrLineIndex(kirtanLineId);
  }, [kirtanLineId]);

  useEffect(() => {
    fetchKirtanPadList();
  }, [database_id]);

  useEffect(() => {
    handleFilterChange();
  }, [searchBarValue, isSearchFocused]);

  useEffect(() => {
    let SqeID = getKirtanById()?.seq_id || 0;
    dispatch(setSeqId(SqeID));
    let BookID = getKirtanById()?.book_id || 0;
    dispatch(setBookId(BookID));
    let databaseId = getKirtanById()?.database_id || 0;
    dispatch(setDatabaseId(databaseId));
  }, [kirtanData, reloadFlag, selectedIndex]);

  useEffect(() => {
    if (selectedIndex) {
      let index = getKirtanById()?.selectedLine || 0;
      handleCurrLineIndex(index);
    }
  }, [selectedIndex]);

  useEffect(() => {
    isDbInitialized &&
      IndexedDBService.getData(Number(selectedIndex), storeName)
        .then((data) => {
          dispatch(setSelectedId(data.selectedPlate));
        })
        .catch((error) => console.error(error));
  }, [isDbInitialized, selectedPlate, selectedIndex]);

  useEffect(() => {
    isDbInitialized &&
      IndexedDBService.getData(Number(selectedIndex), storeName).then((data) => {
        setCurrLineIndex(data.selectedLine);
        dispatch(setCurrKirtanIndex(data.selectedLine));
        setFavLines(data.favLines);
        setLineHistory(data.lineHistory);
        dispatch(setShortcutIndex(null));
        dispatch(setSelectedLine(data.selectedLine));
      });
  }, [selectedIndex, isDbInitialized, reloadFlag]);

  // ─── Single keydown listener — registered ONCE, reads all state via refs ───
  useEffect(() => {
    const handleKeyPress = (event) => {
      const targetTagName = event.target.tagName.toLowerCase();
      if (targetTagName === "input" || targetTagName === "textarea") return;

      // Read the freshest values from refs — no stale closure
      const currentLine = currLineIndexRef.current;
      const currentFavLines = favLinesRef.current;
      const settingsOpen = isSettingsOpenRef.current;
      const preSettingsOpen = isPreSettingsOpenRef.current;
      const getCurrentKirtan = getKirtanByIdRef.current;

      if (settingsOpen || preSettingsOpen) return;

      event.preventDefault();

      const isShortcutPressed = !isNaN(Number(event.key));

      if (isShortcutPressed && event.key !== " " && currentFavLines.length >= Number(event.key)) {
        setUsedShortcut(Number(event.key));
        dispatch(setShortcutIndex(currentFavLines[Number(event.key) - 1]));
      }

      if (event.key === "Escape" || event.key === "Enter" || event.key === " ") {
        handleKey(event);
      }

      switch (event.key) {
        case "Delete":
          handleShowDeleteConfirm(true);
          break;

        case "ArrowUp":
          if (currentLine > 0) {
            handleLineHistory(currentLine);
            handleCurrLineIndex(currentLine - 1);
            setUsedShortcut(null);
            dispatch(setShortcutIndex(null));
          }
          break;

        case "ArrowDown": {
          const kirtan = getCurrentKirtan ? getCurrentKirtan() : null;
          if (kirtan && currentLine < kirtan.content.length - 1) {
            handleLineHistory(currentLine);
            handleCurrLineIndex(currentLine + 1);
            setUsedShortcut(null);
            dispatch(setShortcutIndex(null));
          }
          break;
        }

        case "ArrowLeft":
          handleHistorySwitch(false);
          setUsedShortcut(null);
          dispatch(setShortcutIndex(null));
          break;

        case "ArrowRight":
          handleHistorySwitch(true);
          setUsedShortcut(null);
          dispatch(setShortcutIndex(null));
          break;

        case "q":
          handleClearHistory();
          break;

        case " ":
          break;

        case "F11": {
          const docElm = document.documentElement;
          const isFullScreen =
            document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;

          if (!isFullScreen) {
            if (docElm.requestFullscreen) docElm.requestFullscreen();
            else if (docElm.mozRequestFullScreen) docElm.mozRequestFullScreen();
            else if (docElm.webkitRequestFullscreen) docElm.webkitRequestFullscreen();
            else if (docElm.msRequestFullscreen) docElm.msRequestFullscreen();
          } else {
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
            else if (document.msExitFullscreen) document.msExitFullscreen();
          }
          break;
        }

        default:
          break;
      }
    };

    // Register once — never re-registers, so no listener overlap or stale captures
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, []); // ← empty deps: intentional
  // ───────────────────────────────────────────────────────────────────────────

  const GROUP_COLORS = [
    { name: "Grey", color: "#bdc1c6" },
    { name: "Blue", color: "#1a73e8" },
    { name: "Red", color: "#d93025" },
    { name: "Yellow", color: "#f9ab00" },
    { name: "Green", color: "#1e8e3e" },
    { name: "Pink", color: "#d01716" },
    { name: "Purple", color: "#9334e6" },
    { name: "Cyan", color: "#12b5cb" },
  ];

  const handleReorderKirtanData = (newData) => {
    setKirtanData(newData);
    newData.forEach((item, index) => {
      const updatedItem = { ...item, order: index + 1 };
      IndexedDBService.updateItem(updatedItem, storeName).catch((err) => console.error("Error updating order:", err));
    });
  };

  const handleContextMenu = (event, id) => {
    event.preventDefault();
    setContextKirtanId(id);
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null,
    );
  };

  const handleCloseContextMenu = () => {
    setContextMenu(null);
  };

  const handleAddToGroup = async (groupId) => {
    handleCloseContextMenu();
    const updatedKirtan = kirtanData.find((k) => k.id === contextKirtanId);
    if (updatedKirtan) {
      updatedKirtan.groupId = groupId;
      await IndexedDBService.updateItem(updatedKirtan, storeName);
      setReloadFlag(!reloadFlag);
    }
  };

  const handleCreateGroup = async () => {
    handleCloseContextMenu();
    const newGroup = {
      id: Math.random().toString(36).substr(2, 9),
      title: "New Group",
      color: GROUP_COLORS[1].color,
      collapsed: false,
    };
    await IndexedDBService.addItem(newGroup, tabGroupsStore);
    setTabGroups([...tabGroups, newGroup]);
    handleAddToGroup(newGroup.id);
  };

  const handleUpdateGroupColor = async (groupId, color) => {
    const group = tabGroups.find((g) => g.id === groupId);
    if (group) {
      group.color = color;
      await IndexedDBService.updateItem(group, tabGroupsStore);
      setTabGroups([...tabGroups]);
    }
  };

  const handleRemoveFromGroup = async () => {
    handleCloseContextMenu();
    const updatedKirtan = kirtanData.find((k) => k.id === contextKirtanId);
    if (updatedKirtan) {
      updatedKirtan.groupId = null;
      await IndexedDBService.updateItem(updatedKirtan, storeName);
      setReloadFlag(!reloadFlag);
    }
  };

  const handleUpdateGroupTitle = async (groupId, newTitle) => {
    const group = tabGroups.find((g) => g.id === groupId);
    if (group) {
      group.title = newTitle;
      await IndexedDBService.updateItem(group, tabGroupsStore);
      setTabGroups([...tabGroups]);
    }
  };

  const handleDeleteGroup = async (groupId) => {
    await IndexedDBService.deleteItem(groupId, tabGroupsStore);
    const affectedKirtans = kirtanData.filter((k) => k.groupId === groupId);
    for (const k of affectedKirtans) {
      k.groupId = null;
      await IndexedDBService.updateItem(k, storeName);
    }
    setTabGroups(tabGroups.filter((g) => g.id !== groupId));
    setReloadFlag(!reloadFlag);
  };

  useEffect(() => {
    if (isDbInitialized) {
      IndexedDBService.getAllData(storeName).then((data) => {
        if (data && Array.isArray(data)) {
          data.sort((a, b) => (a.order || 0) - (b.order || 0));
        }
        setKirtanData(data);
      });
      IndexedDBService.getAllData(tabGroupsStore).then((groups) => {
        setTabGroups(groups || []);
      });
    }
  }, [isDbInitialized, selectedIndex, currLineIndex, kirtanLineId, favLines, searchFlag, showDeleteConfirm, reloadFlag]);

  useEffect(() => {
    (async () => {
      if (obs) {
        try {
          await obsClient.connect("ws://localhost:4455");
          const { currentProgramSceneName } = await obsClient.call("GetCurrentProgramScene");
          const { sceneItems } = await obsClient.call("GetSceneItemList", { sceneName: currentProgramSceneName });
          const sourceItem = sceneItems.find((i) => i.sourceName === "Source");
          const icgItem = sceneItems.find((i) => i.sourceName === "ICG");
          const streamStatus = (await obsClient.call("GetStreamStatus")).outputActive;
          const recordingStatus = (await obsClient.call("GetRecordStatus")).outputActive;
          const virtualCamStatus = (await obsClient.call("GetVirtualCamStatus")).outputActive;
          const sourceStatus = sourceItem ? sourceItem.sceneItemEnabled : false;
          const icgStatus = icgItem ? icgItem.sceneItemEnabled : false;
          setIsLive(icgStatus);
          setIsRecord(recordingStatus);
          setIsStream(streamStatus);
          setIsSource(sourceStatus);
          setIsVCam(virtualCamStatus);
        } catch (error) {
          console.error("OBS connection error:", error);
        }
      }
    })();
  }, [obs]);

  return (
    <div
      className="py-1 flex flex-col justify-between bg-[#ffffff] w-full lineBackground relative"
      style={{
        height: "calc(100vh)",
      }}
    >
      <Box className="flex flex-col w-full justify-center items-center">
        <Box className="flex w-full justify-between px-3">
          <Box className="flex w-full overflow-x-auto overflow-y-hidden items-center gap-3 py-1 [scrollbar-width:thin] [&::-webkit-scrollbar]:w-0.5 [&::-webkit-scrollbar]:py-0">
            <Tooltip title="Presets" arrow>
              <Box
                className="hover:bg-gray-100 shrink-0 h-8 w-8 flex items-center justify-center rounded-full duration-200 transition-colors cursor-pointer bg-white shadow-sm border border-gray-200"
                onClick={() => setIsDrawerOpen(true)}
              >
                <i className="fa-solid fa-bars text-gray-700"></i>
              </Box>
            </Tooltip>
            <ReactSortable list={kirtanData} setList={handleReorderKirtanData} className="flex justify-start items-center" animation={200}>
              {kirtanData.map((item, index) => {
                const id = item.id;
                const group = tabGroups.find((g) => g.id === item.groupId);
                const isGroupStart = item.groupId && (index === 0 || kirtanData[index - 1].groupId !== item.groupId);
                const isGroupEnd = item.groupId && (index === kirtanData.length - 1 || kirtanData[index + 1].groupId !== item.groupId);

                return (
                  <Box key={id} className="flex items-center">
                    {isGroupStart && group && (
                      <Box
                        className="flex items-center px-3 py-1 rounded-l-md cursor-pointer hover:bg-gray-100 transition-all border-y border-l"
                        style={{ borderColor: group.color, backgroundColor: `${group.color}15`, marginRight: "-1px" }}
                        onClick={() => {
                          const newTitle = prompt("Enter Group Title", group.title);
                          if (newTitle) handleUpdateGroupTitle(group.id, newTitle);
                        }}
                      >
                        <span className="text-[12px] font-bold uppercase tracking-wider" style={{ color: group.color }}>
                          {group.title}
                        </span>
                      </Box>
                    )}
                    <Box
                      style={{
                        backgroundColor: selectedIndex == id ? "#2196f3" : "#ffffff",
                        color: selectedIndex == id ? "#ffffff" : "#000000",
                        borderTop: group ? `2px solid ${group.color}` : "1px solid #e5e7eb",
                        borderBottom: group ? `2px solid ${group.color}` : "1px solid #e5e7eb",
                        borderLeft: isGroupStart && group ? "none" : group ? "none" : "1px solid #e5e7eb",
                        borderRight: isGroupEnd && group ? `2px solid ${group.color}` : group ? "none" : "1px solid #e5e7eb",
                        borderRadius: group ? (isGroupStart && !isGroupStart ? "0px" : isGroupEnd ? "0 8px 8px 0" : "0px") : "20px",
                        marginLeft: group ? "0px" : "8px",
                        paddingLeft: group ? "12px" : "16px",
                        paddingRight: group ? "12px" : "16px",
                      }}
                      onMouseEnter={() => setHoverKirtanIndex(id)}
                      onMouseLeave={() => setHoverKirtanIndex(null)}
                      onContextMenu={(e) => handleContextMenu(e, id)}
                      className={`kirtanTitle gap-2 flex justify-center items-center cursor-pointer select-none font-semibold h-8 transition-colors ${!group ? "shadow-sm rounded-full" : ""}`}
                      onClick={() => {
                        setSelectedIndex(id);
                        setUsedShortcut(null);
                        dispatch(setKirtanIndex(id));
                      }}
                      onDoubleClick={(e) => {
                        e.stopPropagation();
                        dispatch(setKirtanIndex(id));
                        navigate(`/edit/${id}`);
                      }}
                      onAuxClick={(e) => {
                        if (e.button === 1) {
                          e.preventDefault();
                          deleteKirtanById(id);
                        }
                      }}
                    >
                      {group && <CircleIcon sx={{ fontSize: 8, color: group.color }} />}
                      <p className="text-center text-[14px] whitespace-nowrap">
                        {sulekhToGujUnicodeConverter(item.title).length > 16
                          ? `${sulekhToGujUnicodeConverter(item.title).slice(0, 16)}...`
                          : sulekhToGujUnicodeConverter(item.title)}
                      </p>
                      <Box
                        className={`cross ${hoverKirtanIndex === id ? "opacity-100" : "opacity-0"} duration-200 transition-opacity text-center items-center justify-center hidden`}
                        onClick={() => handleShowDeleteConfirm(true)}
                      >
                        <i
                          className={
                            `fa-solid fa-xmark text-[14px] ml-1 ` + `${selectedIndex == id ? "text-white" : "text-gray-500 hover:text-gray-800"}`
                          }
                        ></i>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </ReactSortable>

            <Menu
              open={contextMenu !== null}
              onClose={handleCloseContextMenu}
              anchorReference="anchorPosition"
              anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
            >
              <MenuItem onClick={handleCreateGroup}>
                <ListItemIcon>
                  <AddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Add tab to new group</ListItemText>
              </MenuItem>

              {tabGroups.length > 0 && <Box className="px-3 py-1 text-[11px] font-bold text-gray-400 uppercase">Existing Groups</Box>}
              {tabGroups.map((group) => (
                <MenuItem key={group.id} onClick={() => handleAddToGroup(group.id)}>
                  <ListItemIcon>
                    <CircleIcon sx={{ color: group.color }} fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{group.title}</ListItemText>
                </MenuItem>
              ))}

              <MenuItem onClick={handleRemoveFromGroup}>
                <ListItemText inset>Remove from group</ListItemText>
              </MenuItem>

              {contextKirtanId && kirtanData.find((k) => k.id === contextKirtanId)?.groupId && (
                <>
                  <Box className="border-t my-1"></Box>
                  <Box className="px-3 py-1 text-[11px] font-bold text-gray-400 uppercase">Group Settings</Box>
                  <Box className="flex flex-wrap gap-1 px-3 py-2 max-w-[200px]">
                    {GROUP_COLORS.map((c) => (
                      <Box
                        key={c.color}
                        onClick={() => {
                          const groupId = kirtanData.find((k) => k.id === contextKirtanId)?.groupId;
                          handleUpdateGroupColor(groupId, c.color);
                          handleCloseContextMenu();
                        }}
                        className="w-6 h-6 rounded-full cursor-pointer hover:scale-110 transition-transform"
                        style={{ backgroundColor: c.color, border: "2px solid white", boxShadow: "0 0 2px rgba(0,0,0,0.2)" }}
                      ></Box>
                    ))}
                  </Box>
                  <MenuItem
                    onClick={() => {
                      const group = tabGroups.find((g) => g.id === kirtanData.find((k) => k.id === contextKirtanId)?.groupId);
                      if (group) handleDeleteGroup(group.id);
                      handleCloseContextMenu();
                    }}
                  >
                    <ListItemText style={{ color: "#d93025" }}>Ungroup</ListItemText>
                  </MenuItem>
                </>
              )}
            </Menu>
            <Tooltip title="Add New" arrow>
              <Box
                className="hover:bg-gray-100 shrink-0 h-8 w-8 flex items-center justify-center rounded-full duration-200 transition-colors cursor-pointer bg-white shadow-sm border border-gray-200 ml-1"
                onClick={() => {
                  navigate("/input");
                }}
              >
                <i className="fa-solid fa-plus text-gray-700"></i>
              </Box>
            </Tooltip>
          </Box>
          <Box className="flex justify-end items-center gap-2 shrink-0 py-1">
            <TextField
              sx={{ ...textFieldStyles, "& .MuiOutlinedInput-root": { borderRadius: "999px", backgroundColor: "#ffffff", height: "32px" } }}
              size="small"
              placeholder="search..."
              value={searchBarValue}
              onChange={handleChangeSearchBarValue}
              onFocus={handleFocus}
              onBlur={handleBlur}
              id="Kirtan_Title_Sulekh"
              autoComplete="off"
              InputProps={inputProp}
            />
            {isSearchFocused && (
              <Tooltip title="Master-Search" arrow>
                <Box
                  className={`flex items-center justify-center cursor-pointer hover:bg-gray-100 h-8 w-8 rounded-full duration-200 transition-colors bg-white shadow-sm border border-gray-200 shrink-0`}
                  onClick={() => {
                    navigate("/search", { state: { oldLocation: "main" } });
                  }}
                  aria-label="open drawer"
                >
                  <i className="fa-solid fa-sliders text-gray-700"></i>
                </Box>
              </Tooltip>
            )}
            <Tooltip title="keyboard" arrow>
              <Box
                className={`flex items-center justify-center cursor-pointer hover:bg-gray-100 h-8 w-8 rounded-full duration-200 transition-colors ${
                  isSerialConnected ? "bg-[#D89F64] text-white border-transparent" : "bg-white text-gray-700 border border-gray-200"
                } shadow-sm shrink-0`}
                onClick={handleConnectClick}
                aria-label="open drawer"
              >
                <i className="fa-brands fa-usb"></i>
              </Box>
            </Tooltip>
            <Tooltip title="Converter" arrow>
              <Box
                className={`flex items-center justify-center cursor-pointer hover:bg-gray-100 h-8 w-8 rounded-full duration-200 transition-colors bg-white shadow-sm border border-gray-200 shrink-0 text-gray-700`}
                onClick={() => {
                  navigate("/converter");
                }}
                aria-label="open drawer"
              >
                <MoveDownIcon sx={{ fontSize: 16 }} />
              </Box>
            </Tooltip>
            <Tooltip title="Form" arrow>
              <Box
                className={`flex items-center justify-center cursor-pointer hover:bg-gray-100 h-8 w-8 rounded-full duration-200 transition-colors bg-white shadow-sm border border-gray-200 shrink-0`}
                onClick={() => {
                  navigate("/kirtan-data");
                }}
                aria-label="open drawer"
              >
                <i className="fa-solid fa-file-export text-gray-700"></i>
              </Box>
            </Tooltip>
            <Tooltip title="V-mix Setting" arrow>
              <Box
                className={`flex items-center justify-center cursor-pointer hover:bg-gray-100 h-8 w-8 rounded-full duration-200 transition-colors bg-white shadow-sm border border-gray-200 shrink-0`}
                onClick={() => {
                  handleModalToggle(true);
                }}
                aria-label="open drawer"
              >
                <i className="fa-solid fa-gear text-gray-700"></i>
              </Box>
            </Tooltip>
          </Box>
          {preSettingModalOpen && <PreSettingModal open={preSettingModalOpen} handlePreSettingModal={handlePreSettingModalToggle} id={presetId} />}
          {searchModalOpen && <SearchModal searchModalOpen={searchModalOpen} handleSearchModalToggle={handleSearchModalToggle} />}

          <SettingModal open={open} handleModalToggle={handleModalToggle} />
        </Box>

        <Box
          className={`flex w-full justify-between gap-4 px-4 h-[100vh] mt-2 ${
            isDualLineMode ? "max-h-[calc(100vh-320px)]" : "max-h-[calc(100vh-250px)]"
          } `}
        >
          <Drawer anchor="left" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
            <div className="flex flex-col justify-evenly items-center bg-[#f1f1f1] overflow-x-hidden w-[80px] h-full">
              {preSettings?.map((item, index) => {
                return (
                  <Button
                    className="h-[40px] mt-2 p-0"
                    key={index}
                    size="small"
                    style={{
                      fontSize: 20,
                      color: item.color,
                      backgroundColor: item.backgroundColor,
                      border: item.id === selectedId ? `4px solid ${item.color}` : `4px solid ${item.backgroundColor}`,
                      minWidth: "40px",
                      borderRadius: "50%",
                      WebkitTextStroke: `${item.textShadowWidth} ${item.textShadowColor}`,
                    }}
                    onClick={() => handlePreSettingApply(item.id)}
                    onDoubleClick={() => handlePreSettingModal(item.id)}
                  >
                    {item.id}
                  </Button>
                );
              })}
            </div>
          </Drawer>

          {/* Kirtan Area */}
          <div
            ref={containerRef}
            className="flex flex-col h-full text-center py-1 shadow-sm border border-[#E9D8B4] overflow-y-auto overflow-x-hidden bg-gradient-to-br from-[#FDF4E1] to-[#F8E7C5] w-1/2 rounded-3xl relative"
          >
            {!isSearchFocused ? (
              getKirtanById() && getKirtanById().content.length > 0 ? (
                <Virtuoso
                  ref={virtuosoRef}
                  data={getKirtanById().content}
                  itemContent={(index, line) => (
                    <Stack
                      ref={selectedLine === index ? selectedLineRef : null}
                      className={`w-full flex justify-center items-center px-2 cursor-pointer transition-all duration-200 border-2 ${
                        selectedLine === index
                          ? isLive
                            ? "border-[#ff4d4f] bg-transparent shadow-sm rounded-full"
                            : "border-[#1890ff] bg-transparent shadow-sm rounded-full"
                          : "border-transparent bg-transparent hover:bg-[#F2DCA5] hover:shadow-sm rounded-full"
                      }`}
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 0, sm: 0, md: 0 }}
                      key={index}
                      onMouseEnter={() => handleRegularLineHover(index)}
                      onMouseLeave={() => handleRegularLineHover(null)}
                    >
                      <div className="justify-center items-center w-full grid grid-cols-3" style={{ gridTemplateColumns: "1fr 35fr 1fr" }}>
                        <div className={`inline ${selectedLine === index ? "opacity-100" : "opacity-0"}`}>
                          <i className="fa-solid fa-hand-point-right text-3xl" style={{ color: "#3170dd" }}></i>
                        </div>
                        <div
                          className="text-3xl text-center kirtan-line-content"
                          key={index + 1}
                          onClick={() => {
                            handleLineHistory(currLineIndex);
                            handleCurrLineIndex(index);
                            setUsedShortcut(null);
                            dispatch(setShortcutIndex(null));
                          }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: line?.replace(/font-size\s*:\s*[^;]+;?/g, ""),
                            }}
                          />
                        </div>
                        <div className={`text-xl font-semibold ${hoveredRegularLineIndex === index ? "opacity-100" : "opacity-0"}`}>
                          {hoveredRegularLineIndex === index && favLines && !favLines.includes(index) ? (
                            <IconButton onClick={() => handleFavLines(index)}>
                              <i className={`fa-solid fa-plus`}></i>
                            </IconButton>
                          ) : (
                            <IconButton onClick={() => handleFavLines(index)}>
                              <i className={`fa-solid fa-minus`}></i>
                            </IconButton>
                          )}
                        </div>
                      </div>
                    </Stack>
                  )}
                />
              ) : null
            ) : (
              <>
                <Box className="w-full h-[100%] flex flex-col shadow-lg rounded-2xl p-4 bg-inherit gap-2 py-2 my-1">
                  <label>Kirtan Title</label>
                  <Box id="title-box" className="h-full">
                    {kirtanList.length > 0 ? (
                      <Virtuoso
                        data={kirtanList}
                        endReached={() => {
                          if (!loaderEffect && !dataReachEaded) {
                            setPageValue((pres) => pres + 1);
                            setLoaderEffect(true);
                          }
                        }}
                        itemContent={(index, kirtan) => (
                          <Stack
                            className={`w-full flex justify-center items-center cursor-pointer bg-inherit no-select`}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={{ xs: 1, sm: 2, md: 4 }}
                          >
                            <div
                              className="w-full text-2xl text-center cursor-pointer hover:bg-slate-50 hover:rounded-full"
                              style={{ fontFamily: "Guj_Gopika_Two_Bold" }}
                              onClick={() => {
                                handleSeqFetchData(kirtan, false);
                              }}
                            >
                              <p className="text-center flex justify-center items-center">
                                <span
                                  className="text-[#0000ff]"
                                  style={{
                                    fontFamily: `Roboto, Helvetica, Arial, sans-serif`,
                                    fontSize: "15px",
                                  }}
                                >{`#${findBookShortName(kirtan.book_id)}-${kirtan.seq_id}`}</span>
                                -{`${kirtan.title}`}
                              </p>
                            </div>
                          </Stack>
                        )}
                        components={{
                          Footer: () =>
                            loaderEffect ? (
                              <Stack
                                className={`w-full flex justify-center items-center cursor-pointer bg-inherit no-select`}
                                direction={{ xs: "column", sm: "row" }}
                                spacing={{ xs: 1, sm: 2, md: 4 }}
                              >
                                <div className="w-full text-2xl text-center mb-3">
                                  <CircularProgress />
                                </div>
                              </Stack>
                            ) : null,
                        }}
                      />
                    ) : null}
                  </Box>
                </Box>
              </>
            )}
          </div>

          {/* VMix buttons */}
          <div className="flex flex-col justify-between items-center">
            {!obs ? (
              <div className="flex flex-col justify-center items-center gap-2 ">
                <img className="h-16 bg-[#EEEEEE] rounded-full" src="/images/Kundal_Logo.png" alt="Maharaj"></img>
              </div>
            ) : (
              <div className="flex flex-col justify-center items-center gap-2 "></div>
            )}
            <div className="flex flex-col justify-center items-center gap-2 h-full">
              <TimerButton></TimerButton>
            </div>
            <div className="flex flex-col justify-center items-center gap-2 h-full">
              <Button
                className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button`}
                style={{ backgroundColor: isLive ? "#D89F64" : "#EEEEEE", color: isLive ? "#ffffff" : "#535353", borderRadius: "999px" }}
                variant="contained"
                onClick={() => {
                  handleChange(!isLive);
                }}
              >
                <RemoveRedEyeIcon fontSize="medium" />
              </Button>
              <p>Overlay</p>
            </div>
            {!obs && (
              <div className="flex flex-col justify-center items-center gap-2 h-full">
                <Button
                  className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button`}
                  style={{ backgroundColor: "#EEEEEE", color: "#535353", borderRadius: "999px" }}
                  variant="contained"
                  onClick={() => {
                    handleScreenShotClick(true);
                  }}
                >
                  <ScreenshotMonitorIcon fontSize="medium" />
                </Button>
                <p>ScreenShot</p>
              </div>
            )}
            {sourceMode && (
              <div className="flex flex-col justify-center items-center gap-2 h-full">
                <Button
                  className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button`}
                  disabled={!sourceMode}
                  style={{ backgroundColor: isSource ? "#D89F64" : "#EEEEEE", color: isSource ? "#ffffff" : "#535353", borderRadius: "999px" }}
                  variant="contained"
                  onClick={() => {
                    handleVMixButtonsClick("sourceOverlay");
                  }}
                >
                  <VideoCameraBackIcon fontSize="medium" />
                </Button>
                <p>Source</p>
              </div>
            )}
            {recordMode && (
              <div className="flex flex-col justify-center items-center gap-2 h-full">
                <Button
                  className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button `}
                  disabled={!recordMode}
                  style={{ backgroundColor: isRecord ? "#D89F64" : "#EEEEEE", color: isRecord ? "#ffffff" : "#535353", borderRadius: "999px" }}
                  variant="contained"
                  onClick={() => {
                    handleVMixButtonsClick("record");
                  }}
                >
                  <RadioButtonCheckedIcon fontSize="medium" />
                </Button>
                <p>Record</p>
              </div>
            )}
            {streamMode && (
              <div className="flex flex-col justify-center items-center gap-2 h-full">
                <Button
                  className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button `}
                  disabled={!streamMode}
                  style={{ backgroundColor: isStream ? "#D89F64" : "#EEEEEE", color: isStream ? "#ffffff" : "#535353", borderRadius: "999px" }}
                  variant="contained"
                  onClick={() => {
                    handleVMixButtonsClick("stream");
                  }}
                >
                  <CastIcon fontSize="medium" />
                </Button>
                <p>Stream</p>
              </div>
            )}
            {vCam && (
              <div className="flex flex-col justify-center items-center gap-2 h-full">
                <Button
                  className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button `}
                  disabled={!vCam}
                  style={{ backgroundColor: isVCam ? "#D89F64" : "#EEEEEE", color: isVCam ? "#ffffff" : "#535353", borderRadius: "999px" }}
                  variant="contained"
                  onClick={() => {
                    handleVMixButtonsClick("vCam");
                  }}
                >
                  <CastIcon fontSize="medium" />
                </Button>
                <p>vCam</p>
              </div>
            )}
            {!obs && (
              <div className="flex flex-col justify-center items-center gap-2 h-full">
                <Button
                  className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button`}
                  style={{
                    backgroundColor: multiScreenShotProcess ? "#D89F64" : "#EEEEEE",
                    color: multiScreenShotProcess ? "#ffffff" : "#535353",
                    borderRadius: "999px",
                  }}
                  variant="contained"
                  onClick={() => {
                    handleMultiScreenShot();
                  }}
                >
                  <ScreenshotMonitorIcon fontSize="medium" />
                </Button>
                <div className="flex flex-col justify-center items-center">
                  <p>Multi</p>
                  <p>ScreenShot</p>
                </div>
              </div>
            )}
          </div>

          {/* fav line */}
          <div className="flex items-center flex-col text-center py-4 px-2 shadow-sm border border-[#E9D8B4] overflow-y-auto overflow-x-hidden bg-gradient-to-br from-[#FDF4E1] to-[#F8E7C5] w-1/2 rounded-3xl relative">
            {!isSearchFocused ? (
              <>
                <div className="w-full flex-1 min-h-[50%]">
                  <ReactSortable list={favLines} setList={getUpdatedList} className="w-full" handle=".drag-handle">
                    {favLines?.map((line, index) => {
                      return (
                        <Stack
                          className={`w-full grid grid-cols-3 justify-between items-center transition-all duration-200 border-2 ${
                            usedShortcut - 1 === index
                              ? isLive
                                ? "border-[#ff4d4f] bg-transparent shadow-sm rounded-full"
                                : "border-[#1890ff] bg-transparent shadow-sm rounded-full"
                              : "border-transparent bg-transparent hover:bg-[#F2DCA5] hover:shadow-sm rounded-full"
                          }`}
                          style={{
                            gridTemplateColumns: "1fr 1fr 1fr",
                          }}
                          direction={{ xs: "column", sm: "row" }}
                          spacing={{ xs: 1, sm: 2, md: 4 }}
                          onMouseEnter={() => handleFavLineHover(line)}
                          onMouseLeave={() => handleFavLineHover(null)}
                          onClick={() => {
                            setUsedShortcut(index + 1);
                          }}
                          key={index}
                        >
                          <Box className="flex items-center justify-center ">
                            <Box className={`${index < 9 ? "opacity-100" : "opacity-0"} w-20` + ` flex items-center justify-center`}>
                              <Button
                                sx={{
                                  height: "30px",
                                  minWidth: "30px",
                                  borderRadius: "999px",
                                }}
                                size="small"
                                variant="contained"
                              >
                                {index + 1}
                              </Button>
                            </Box>

                            <Box
                              className={`text-xl drag-handle cursor-grab bg-inherit hover:bg-inherit ${
                                hoveredFavLineIndex === line ? "opacity-100" : "opacity-0"
                              }`}
                            >
                              <i className="fa-solid fa-grip-vertical text-base"></i>
                            </Box>
                          </Box>
                          <div
                            className="text-2xl text-center cursor-pointer w-full"
                            onClick={() => {
                              dispatch(setShortcutIndex(line));
                            }}
                            dangerouslySetInnerHTML={{
                              __html: getKirtanById()?.content?.[line]?.replace(/font-size\s*:\s*[^;]+;?/g, ""),
                            }}
                          />

                          <div className={`text-xl font-semibold ${hoveredFavLineIndex === line ? "opacity-100" : "opacity-0"}`}>
                            {hoveredFavLineIndex === line && !favLines.includes(line) ? (
                              <IconButton onClick={() => handleFavLines(line)}>
                                <i className="fa-solid fa-plus"></i>
                              </IconButton>
                            ) : (
                              <IconButton onClick={() => handleFavLines(line)}>
                                <i className="fa-solid fa-minus"></i>
                              </IconButton>
                            )}
                          </div>
                        </Stack>
                      );
                    })}
                  </ReactSortable>
                </div>
                <div className="flex flex-col w-full mt-auto pt-2 shrink-0">
                  <div className="mt-auto w-full flex flex-col items-center">
                    <Box className="flex flex-wrap w-full justify-center items-center gap-3">
                      {padList &&
                        padList.length > 1 &&
                        padList.map((kirtan) => {
                          return (
                            <Button
                              size="small"
                              className={`w-[35%] z-10 shadow-sm ${kirtan.id === database_id ? "bg-white" : ""} `}
                              sx={{
                                borderRadius: "999px",
                                fontSize: "1.35rem",
                                lineHeight: "2rem",
                                padding: "0px 16px",
                                color: "black",
                                fontFamily: "Ghanu_unicode_bold_Guj",
                                backgroundColor: kirtan.id === database_id ? "#ffffff" : "#D8B693",
                                textTransform: "none",
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: "8px",
                                "&:hover": {
                                  backgroundColor: "#Ead3b8",
                                },
                              }}
                              onClick={() => handlePadClick(kirtan.id)}
                            >
                              <span style={{ minWidth: "24px", textAlign: "right", flexShrink: 0 }}>{kirtan.pad_no}</span>
                              <span style={{ flexShrink: 0 }}>-</span>
                              <span
                                style={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  flexGrow: 1,
                                  textAlign: "left",
                                }}
                              >
                                {sulekhToGujUnicodeConverter(kirtan.title)}
                              </span>
                            </Button>
                          );
                        })}
                    </Box>
                  </div>
                  <div className="flex gap-2 w-full justify-between items-end mt-3 shrink-0 pb-2">
                    <Box>
                      <Button
                        className="h-[50px] z-10 p-0 shadow-lg"
                        sx={{
                          borderRadius: "999px",
                          minWidth: "50px",
                          backgroundColor: "#D89F64",
                        }}
                        onClick={handlePrevious}
                      >
                        <i className="fa-solid fa-angles-left fa-2xl text-[#FFFFFF]"></i>
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        className="h-[50px] z-10 p-0 shadow-lg"
                        sx={{
                          borderRadius: "999px",
                          minWidth: "50px",
                          backgroundColor: "#D89F64",
                        }}
                        onClick={handleNext}
                      >
                        <i className="fa-solid fa-angles-right fa-2xl text-[#FFFFFF]"></i>
                      </Button>
                    </Box>
                  </div>
                </div>
              </>
            ) : (
              <>
                <Box className="w-full h-[100%] flex flex-col shadow-lg rounded-2xl p-4 bg-inherit gap-2 py-2 my-1">
                  <label className="static">Kirtan Content</label>
                  <Box id="content-box" className="h-full">
                    {content_kirtan_list.length > 0 ? (
                      <Virtuoso
                        data={content_kirtan_list}
                        endReached={() => {
                          if (!loaderEffect && !dataReachEaded) {
                            setPageValue((pres) => pres + 1);
                            setLoaderEffect(true);
                          }
                        }}
                        itemContent={(index, kirtan) => (
                          <Stack
                            className={`w-full flex justify-center items-center cursor-pointer bg-inherit no-select`}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={{ xs: 1, sm: 2, md: 4 }}
                          >
                            <div
                              className="w-full text-2xl text-center cursor-pointer hover:bg-slate-50 hover:rounded-full"
                              style={{ fontFamily: "Guj_Gopika_Two_Bold" }}
                              onClick={() => handleSeqFetchData(kirtan, false)}
                            >
                              <p className="text-center flex justify-center items-center ">
                                <span
                                  className="text-[#0000ff]"
                                  style={{
                                    fontFamily: `Roboto, Helvetica, Arial, sans-serif`,
                                    fontSize: "15px",
                                  }}
                                >{`#${findBookShortName(kirtan.book_id)}-${kirtan.seq_id}`}</span>
                                -{`${kirtan.title}`}
                              </p>
                            </div>
                          </Stack>
                        )}
                        components={{
                          Footer: () =>
                            loaderEffect ? (
                              <Stack
                                className={`w-full flex justify-center items-center cursor-pointer bg-inherit no-select`}
                                direction={{ xs: "column", sm: "row" }}
                                spacing={{ xs: 1, sm: 2, md: 4 }}
                              >
                                <div className="w-full text-2xl text-center mb-3">
                                  <CircularProgress />
                                </div>
                              </Stack>
                            ) : null,
                        }}
                      />
                    ) : null}
                  </Box>
                </Box>
              </>
            )}
          </div>
        </Box>
      </Box>
      <Box className="absolute bottom-0 w-full mt-3">
        {
          <Box size="small" className={`relative flex justify-between items-center text-[#2497F2] px-6 py-2 w-full bg-transparent`}>
            {database_id && database_id !== 0 && (
              <Box
                size="small"
                className={`text-[15px] z-50 text-center min-w-max whitespace-nowrap bg-blue-50 text-blue-700 px-4 py-1.5 rounded-full border border-blue-200 shadow-sm mr-6 font-bold`}
              >
                {`${findBookName(book_id)} - ${getKirtanById()?.page_no}(${getKirtanById()?.seq_id})`}
              </Box>
            )}

            <Box className={`flex flex-row justify-center gap-3 items-center w-full flex-wrap`}>
              {!obs && vMixZoomButton.length > 0 ? (
                vMixZoomButton.map((item, index) => {
                  return (
                    <Box
                      key={index}
                      size="small"
                      className={`text-base font-bold z-50 text-center cursor-pointer flex justify-center items-center w-9 h-9 rounded-full shadow-sm transition-all duration-200`}
                      style={{
                        backgroundColor: selectedOnZoomButton.includes(index + 1) ? "#1976d2" : "#f0f6ff",
                        color: selectedOnZoomButton.includes(index + 1) ? "white" : "#1976d2",
                        border: selectedOnZoomButton.includes(index + 1) ? "2px solid #1976d2" : "2px solid #b6d4fe",
                      }}
                      onClick={() => {
                        handleZoomCLick(index + 1);
                      }}
                    >
                      {item.name}
                    </Box>
                  );
                })
              ) : (
                <>
                  <Box
                    size="small"
                    className={`text-base font-bold z-50 text-center cursor-pointer flex justify-center items-center px-4 py-1.5 rounded-full shadow-sm transition-all duration-200`}
                    style={{
                      backgroundColor: selectedProjection === "Z1" ? "#1976d2" : "#f0f6ff",
                      color: selectedProjection === "Z1" ? "white" : "#1976d2",
                      border: selectedProjection === "Z1" ? "2px solid #1976d2" : "2px solid #b6d4fe",
                    }}
                    onClick={() => {
                      handleProjectionButtonClick("Z1");
                    }}
                  >
                    Z1
                  </Box>
                  <Box
                    size="small"
                    className={`text-base font-bold z-50 text-center cursor-pointer flex justify-center items-center px-4 py-1.5 rounded-full shadow-sm transition-all duration-200`}
                    style={{
                      backgroundColor: selectedProjection === "Z2" ? "#1976d2" : "#f0f6ff",
                      color: selectedProjection === "Z2" ? "white" : "#1976d2",
                      border: selectedProjection === "Z2" ? "2px solid #1976d2" : "2px solid #b6d4fe",
                    }}
                    onClick={() => {
                      handleProjectionButtonClick("Z2");
                    }}
                  >
                    Z2
                  </Box>
                  <Box
                    size="small"
                    className={`text-base font-bold z-50 text-center cursor-pointer flex justify-center items-center px-4 py-1.5 rounded-full shadow-sm transition-all duration-200`}
                    style={{
                      backgroundColor: selectedProjection === "Kirtan" ? "#1976d2" : "#f0f6ff",
                      color: selectedProjection === "Kirtan" ? "white" : "#1976d2",
                      border: selectedProjection === "Kirtan" ? "2px solid #1976d2" : "2px solid #b6d4fe",
                    }}
                    onClick={() => {
                      handleProjectionButtonClick("Kirtan");
                    }}
                  >
                    Kirtan
                  </Box>
                  <Box
                    size="small"
                    className={`text-base font-bold z-50 text-center cursor-pointer flex justify-center items-center px-4 py-1.5 rounded-full shadow-sm transition-all duration-200`}
                    style={{
                      backgroundColor: selectedProjection === "Output" ? "#1976d2" : "#f0f6ff",
                      color: selectedProjection === "Output" ? "white" : "#1976d2",
                      border: selectedProjection === "Output" ? "2px solid #1976d2" : "2px solid #b6d4fe",
                    }}
                    onClick={() => {
                      handleProjectionButtonClick("Output");
                    }}
                  >
                    Output
                  </Box>
                </>
              )}
              {!obs && (
                <Box
                  key={11}
                  size="small"
                  className={`text-lg z-50 text-center cursor-pointer flex justify-center items-center w-10 h-10 rounded-full hover:bg-blue-50 transition-colors ml-4`}
                  onClick={() => navigate("/zoom")}
                >
                  <img src="/images/vmixapi_icon.png" alt="V-mix" width="24" height="24" />
                </Box>
              )}
            </Box>

            <Box
              size="small"
              className={`text-base shrink-0 ml-6 z-50 text-center cursor-pointer flex justify-center items-center font-bold px-5 py-1.5 rounded-full shadow-sm bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 transition-colors`}
              onClick={() => {
                navigate("/manglacharan");
              }}
            >
              Manglacharan
            </Box>
          </Box>
        }
        <KirtanLinePlate reloadFlag={reloadFlag} />
      </Box>
      <ConfirmBox
        open={showDeleteConfirm}
        handleClose={handleShowDeleteConfirm}
        handleConfirm={handleDelete}
        title={"Confirm Close Tab"}
        msg={"Are you sure you want to Close this Kirtan Tab?"}
        type={"delete"}
      />
    </div>
  );
};

export default KirtanArea;
